import { render, staticRenderFns } from "./WorkspaceExpandProgressOverlay.vue?vue&type=template&id=037c1432&scoped=true"
import script from "./WorkspaceExpandProgressOverlay.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpandProgressOverlay.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpandProgressOverlay.vue?vue&type=style&index=0&id=037c1432&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c1432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037c1432')) {
      api.createRecord('037c1432', component.options)
    } else {
      api.reload('037c1432', component.options)
    }
    module.hot.accept("./WorkspaceExpandProgressOverlay.vue?vue&type=template&id=037c1432&scoped=true", function () {
      api.rerender('037c1432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpandProgressOverlay.vue"
export default component.exports